import { createUserManager } from 'redux-oidc';
import * as Constants from '../constants/Constants';

const configuration = {
    client_id: Constants.TC_KEY_ID,
    redirect_uri: Constants.REDIRECT_URI,
    response_type: 'code',
    scope: Constants.SCOPE_NAME,
    authority: Constants.AUTHORITY_NAME,
    loadUserInfo: false,
    post_logout_redirect_uri: Constants.LOGOUT_REDIRECT_URI,
    revokeAccessTokenOnSignout: true,
    automaticSilentRenew: true,
    extraQueryParams: { identity_provider: Constants.TRIMBLE_AUTOMATION }
};

const automationAuthenticationManager = createUserManager(configuration);

export default automationAuthenticationManager;
